import { useMutation, useQueryClient } from '@tanstack/react-query'
import { showSuccessToast } from '@bpinternal/ui-kit-next'
import { useQueryKeys } from '../useQueryKeys'
import { getApiClient } from '../../stores'

type UpdateAiSpendParams = {
  workspaceId: string
  monthlySpendingLimit: number
  onSuccess?: () => void
  onError?: () => void
}

export function useUpdateAiSpend() {
  const queryClient = useQueryClient()
  const { getWorkspaceUsages } = useQueryKeys()

  return useMutation({
    mutationFn: async ({ workspaceId, monthlySpendingLimit }: UpdateAiSpendParams) => {
      return await getApiClient({ workspaceId }).changeAISpendQuota({ monthlySpendingLimit })
    },
    onSuccess: async (_, { onSuccess, workspaceId }) => {
      await queryClient.invalidateQueries({
        queryKey: getWorkspaceUsages(workspaceId, new Date().toISOString().split('T')[0], ['ai_spend']),
      })
      showSuccessToast('Your AI spend limit has been updated successfully.')
      onSuccess?.()
    },
    onError: (_, { onError }) => {
      onError?.()
    },
  })
}
